import Typography from "@mui/material/Typography";
import type { TypographyProps } from "@mui/material/Typography";

export interface CurrencyProps extends Omit<TypographyProps, "children"> {
  amount: number;
  currency?: string;
  startLabel?: string;
}

export function Currency({
  variant,
  sx,
  amount,
  currency = "TRY",
  startLabel,
  ...props
}: CurrencyProps) {
  return (
    <Typography variant={variant} sx={sx} {...props}>
      {startLabel}
      {Number.prototype.toCurrencyFormat(amount, currency)}
    </Typography>
  );
}
